import * as actions from "./actions";

export default function cloneReducer(state = [], action) {
    switch (action.type) {

    case actions.GET_CLONE_SUCCESS:
    case actions.GET_CLONE_FAIL:
    {
        return action.payload;
    }
    default:
        return state;

    }
}
